import JSZip from "jszip";
import { saveAs } from "file-saver";
const openpgp = require("openpgp");
import Vue from "vue";


async function zipAndDownload(blob, token) {
  //create zip file
  var zip = new JSZip();

  // create a file
  zip.file("wireless_config", blob);
  zip.file("token", token);

  let result = await zip
    .generateAsync({ type: "blob" })
    .then(function (zipFile) {
      //Under the hood, the polyfill uses the native saveAs from the FileSaver API (on Chrome and IE10+) or use a Blob URL (on Firefox).
      try {
        saveAs(zipFile, "onboarding.zip");
        return true;
      } catch (err) {
        Vue.$log.error(err);
        return false;
      }
    })
    .catch(function (err) {
      Vue.$log.error(err);
      return false;
    });

  return result;
}

async function createEncryptedBlob(ssid, password, protocol, countryCode) {
  //create config in the correct format
  let cfgContent = `ssid='${ssid}'\nkey='${password}'\nenc='${protocol}'\ncountry='${countryCode}'`;

  //create an encrypted blob to use content as download
  let blob;
  await openpgp
    .encrypt({
      message: openpgp.message.fromText(cfgContent),
      passwords: [process.env.VUE_APP_USB_PW]
    })
    .then(ciphertext => {
      //create a blob to use content as download
      blob = new Blob([ciphertext.data], {
        type: "application/octet-stream"
      });
    })
    .catch(error => {
      Vue.$log.error(error);
      return null;
    });

  return blob;
}

async function createEncryptedToken(token) {
  //create an encrypted blob to use content as download
  let enryptedToken = await openpgp
    .encrypt({
      message: openpgp.message.fromText(token),
      passwords: [process.env.VUE_APP_USB_PW]
    })
    .then(ciphertext => {
      return ciphertext.data;
    })
    .catch(error => {
      Vue.$log.error(error);
      return null;
    });

  return enryptedToken;
}

export default { zipAndDownload, createEncryptedBlob, createEncryptedToken };
